/**
 * Subtle Early-Access trust banner.
 *
 * Per the P0 UX brief: visitors should know Sentient Vault is in
 * Early Access — NOT framed as "unstable" or "use at your own
 * risk", but as a Founding-Customer programme with active product
 * development.
 *
 * Two variants:
 *   - default: inline banner (sits below page header)
 *   - compact: single-line, narrow contexts (auth-page top bars)
 */
import { Sparkles } from "lucide-react";

const COPY = (
  "Sentient Vault is currently in early-stage development. " +
  "We are actively improving document intelligence, financial " +
  "truth analysis and obligation management before wider " +
  "public release."
);

export default function EarlyAccessBanner({
  variant = "default",
  testId = "early-access-banner",
}) {
  if (variant === "compact") {
    return (
      <div
        data-testid={testId}
        className="flex items-center gap-2 rounded-lg border border-amber-500/15 bg-amber-500/[0.04] px-3 py-2"
      >
        <Sparkles className="w-3.5 h-3.5 text-amber-400/80 shrink-0" />
        <span className="text-[11px] text-slate-400 leading-snug">
          <span className="text-amber-300/90 font-medium">
            Early Development Preview
          </span>
          {" — "}
          <span className="text-slate-500">
            Refining document intelligence before wider public release.
          </span>
        </span>
      </div>
    );
  }

  return (
    <div
      data-testid={testId}
      className="rounded-2xl border border-amber-500/15 bg-amber-500/[0.04] px-5 py-4 flex items-start gap-3"
    >
      <div className="w-8 h-8 rounded-lg border border-amber-500/25 bg-amber-500/[0.08] flex items-center justify-center shrink-0">
        <Sparkles className="w-4 h-4 text-amber-400" />
      </div>
      <div className="flex-1">
        <div className="flex items-center gap-3 mb-1">
          <span
            className="text-[10px] uppercase tracking-[0.2em] font-manrope text-amber-300/90"
            data-testid={`${testId}-tag`}
          >
            Early Development Preview
          </span>
        </div>
        <p className="text-sm text-slate-400 leading-relaxed">
          {COPY}
        </p>
      </div>
    </div>
  );
}
